import { useModal } from '@ebay/nice-modal-react';

import NotificationsButtonComponent from './NotificationsButtonComponent';
import NotificationsDropdownButton from './NotificationsDropdownButton';
import NotificationsMobileModal from './NotificationsMobileModal';
import useMentionNotifications from './useMentionNotifications';
import useMessengerMessageNotifications from './useMessengerMessageNotifications';
import useReactionNotifications from './useReactionNotifications';

// Invite notifications (workspace, messenger room, meeting space) are mounted by the
// root-level InviteNotificationsFeeder so they survive route changes into a call (#8150).
const NotificationsButton = () => {
  const { show } = useModal(NotificationsMobileModal);
  useMessengerMessageNotifications();
  useMentionNotifications();
  useReactionNotifications();

  return (
    <>
      <NotificationsButtonComponent className="block md:hidden" onClick={show} />
      <NotificationsDropdownButton className="hidden md:block" />
    </>
  );
};

export default NotificationsButton;
